import { useState } from 'react';

interface InlineRegisterProps {
  onRegister: (data: {
    email: string;
    password: string;
    firstName?: string;
    lastName?: string;
  }) => Promise<{ success: boolean; error?: string }>;
  onSwitchToLogin?: () => void;
  onCancel?: () => void;
}

export default function InlineRegister({
  onRegister,
  onSwitchToLogin,
  onCancel,
}: InlineRegisterProps) {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await onRegister({
      email,
      password,
      firstName: firstName.trim() || undefined,
    });
    setLoading(false);
    if (result.success) {
      setSuccess(true);
    } else {
      setError(result.error || 'Registration failed');
    }
  };

  if (success) {
    return (
      <div className="inline-auth">
        <p className="inline-auth-success">
          Account created! Check your email to verify your address, then sign in.
        </p>
        {onSwitchToLogin && (
          <button type="button" className="btn btn-primary" onClick={onSwitchToLogin}>
            Back to Sign In
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="inline-auth">
      <form onSubmit={handleSubmit} className="inline-auth-form">
        <div className="contact-field">
          <label htmlFor="reg-first-name">First name</label>
          <input
            id="reg-first-name"
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            autoComplete="given-name"
            placeholder="Jane"
          />
        </div>
        <div className="contact-field">
          <label htmlFor="reg-email">Email *</label>
          <input
            id="reg-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            placeholder="you@example.com"
          />
        </div>
        <div className="contact-field">
          <label htmlFor="reg-password">Password *</label>
          <input
            id="reg-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
            placeholder="At least 8 characters"
          />
        </div>

        {error && <p className="inline-auth-error">{error}</p>}

        <div className="inline-auth-actions">
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Creating…' : 'Create Account'}
          </button>
          {onCancel && (
            <button type="button" className="btn btn-secondary" onClick={onCancel}>
              Cancel
            </button>
          )}
        </div>
      </form>

      {onSwitchToLogin && (
        <div className="inline-auth-links">
          <button type="button" className="inline-auth-link-btn" onClick={onSwitchToLogin}>
            Already have an account? Sign in
          </button>
        </div>
      )}
    </div>
  );
}
